import * as React from 'react';
import propz from 'propz';
import { SchoolEvent, SchoolEventTeamDataPlayer } from 'Src/models/event';
import { getPositionNameById } from 'Src/helpers/event/event';

interface Props {
  player: SchoolEventTeamDataPlayer;
  event: SchoolEvent;
}

export function StudentEventTeamPlayerPosition(props: Props) {
  const { player, event } = props;

  let position = null;

  const playerData = event.players.find(eventPlayer => eventPlayer._id === player.id);
  const positionId: string = propz.get(playerData, ['positionId']);

  if (typeof positionId !== 'undefined') {
    const playerTeamId: string = player.teamId;
    const team = event.embeddedTeams.find(embeddedTeam => embeddedTeam._id === playerTeamId);
    const teamPositionName: string | undefined = propz.get(team, ['positionName'], undefined);
    const playerPositionName: string = getPositionNameById(positionId, event);

    if (typeof teamPositionName !== 'undefined') {
      position = `${playerPositionName.toLowerCase()} / ${teamPositionName.toLowerCase()}`;
    } else {
      position = `${playerPositionName.toLowerCase()}`;
    }
  }

  return position;
}

